import { Box, Typography, useTheme } from '@mui/material'
import { CSSProperties } from 'react'
import { Trans } from 'react-i18next'

export const CTAPcfAtScale = ({
	justifyContent = 'initial',
}: {
	justifyContent?: CSSProperties['justifyContent']
}) => {
	const theme = useTheme()
	return (
		<Box
			display="flex"
			alignItems="center"
			pb={2}
			mt={2}
			justifyContent={justifyContent}
		>
			<Typography variant="body2" color={theme.palette.fonts.secondary}>
				{/* eslint-disable react/jsx-no-literals */}
				<Trans i18nKey="pcfCallToAction">
					Looking to calculate product carbon footprint at scale for your
					product portfolio?
					<a
						href="https://www.co2ai.com/request-a-demo"
						target="_blank"
						rel="noreferrer"
					>
						contact us
					</a>
				</Trans>
				{/* eslint-enable react/jsx-no-literals */}
			</Typography>
		</Box>
	)
}
